import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-488053d1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex justify-space-between px-10 py-4 pagination-bottom" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex align-center gap-1 text-md color-text"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Mostrando", -1))
const _hoisted_4 = {
  class: "pagination-container",
  "aria-label": "row pagination"
}
const _hoisted_5 = {
  key: 0,
  class: "pagination px-1"
}
const _hoisted_6 = ["aria-label", "onClick"]

import { toRefs, computed, ref, watch } from 'vue';
import { BtnRightIcon } from '../atoms';


export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculePagination',
  props: {
  numberOfPages: {
    required: true,
  },
  modelValue: {
    required: true,
    type: Number,
  },
  perPage: {
    required: false,
    type: Number,
  },
  optionsPerPage: {
    required: false,
    type: Array,
  },
  totalItems: {
    required: false,
    type: Number,
  },
},
  emits: ['update:modelValue', 'changePerPage'],
  setup(__props, { emit: __emit }) {

const props = __props;

const { numberOfPages, modelValue: currentPage } = toRefs<any>(props);
const perPageTable = ref(props.perPage);

const emit = __emit;

const pages = computed(() => {
  let numShown = 6;
  numShown = Math.min(numShown, numberOfPages.value);
  let first = currentPage.value - Math.floor(numShown / 2);
  first = Math.max(first, 1);
  first = Math.min(first, numberOfPages.value - numShown + 1);
  return [...Array(numShown)].map((k, i) => i + first);
});

const setCurrentPage = (number: any) => {
  emit('update:modelValue', number);
};

const previous = () => {
  if (currentPage.value === 1) return;
  emit('update:modelValue', currentPage.value - 1);
};

const next = () => {
  if (currentPage.value >= numberOfPages?.value) return;
  emit('update:modelValue', currentPage.value + 1);
};

function changePerPage() {
  emit('changePerPage', perPageTable.value);
}
watch(
  () => props.perPage,
  () => {
    perPageTable.value = props.perPage;
  }
);
watch(
  () => perPageTable.value,
  () => {
    changePerPage();
  }
);

return (_ctx: any,_cache: any) => {
  const _component_VSelect = _resolveComponent("VSelect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.optionsPerPage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_VSelect, {
            "bg-color": "var(--secondary-c600)",
            modelValue: perPageTable.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((perPageTable).value = $event)),
            class: "d-flex align-center custom-v-select",
            items: props.optionsPerPage,
            variant: "solo",
            density: "compact",
            "item-class": "white-text",
            onInput: changePerPage
          }, null, 8, ["modelValue", "items"]),
          _createElementVNode("p", null, "de " + _toDisplayString(props.totalItems) + " resultados", 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      (_unref(numberOfPages) >= 1)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
            _createElementVNode("li", {
              class: _normalizeClass(["navigation", {
            disabled: _unref(currentPage) === 1,
          }]),
              "aria-label": "go to previous page",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (previous()))
            }, [
              _createVNode(_unref(BtnRightIcon), { class: "prev" })
            ], 2),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pages.value, (index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: index,
                "aria-label": 'go to page ' + index,
                class: "page-item",
                onClick: ($event: any) => (setCurrentPage(index))
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["page-link", {
              'active-page': _unref(currentPage) === index,
            }])
                }, _toDisplayString(index), 3)
              ], 8, _hoisted_6))
            }), 128)),
            _createElementVNode("li", {
              class: _normalizeClass(["navigation", {
            disabled: _unref(currentPage) === _unref(numberOfPages) || !_unref(numberOfPages),
          }]),
              "aria-label": "go to next page",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (next()))
            }, [
              _createVNode(_unref(BtnRightIcon))
            ], 2)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})